module.exports = __webpack_public_path__ + "img/9788939206649.45fd158e.jpg";